import React, { useLayoutEffect } from "react";
import { useMedia } from "use-media";
import logo from "../../resources/icons/logo_reservations.svg";
import { Label } from "../atoms/label";
import { Link } from "../atoms/link";
import { useHistory } from "react-router-dom";
import { useStore } from "react-redux";
import "../../resources/css/soloReserve/golfSoloHeader.css"

export const GolfSoloHeaderContainer = (props) => {
  const { onClickOpenReservationPopupWindow, setPathSetLoading } = props;
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const history = useHistory();
  const store = useStore();
  const prevScreenInfo = store.getState().prevScreenInfo;

  // ページ遷移管理処理
  useLayoutEffect(() => {
    store.dispatch({ type: "PREV_SCREEN_INFO", payload: { prevScreenInfo: { currentPath: history.location.pathname, prevPath: prevScreenInfo.currentPath } } });
    if (setPathSetLoading) {
      setPathSetLoading(false);
    }
  }, [])

  const onClickBack = () => {
    if (props.reserveDetailFlg) {
      history.push(props.path, { locationFlg: true });
    } else {
      history.push(props.path);
    }
  };
  const onClickIcon = () => {
    if (props.confirmCheck === undefined || props.reserveCheck) {
      history.push("/reserve/top");
    }
  };
  const login = store.getState().login;

  return (
    <div>
      <div className="soloHeader_base">
        <img onClick={onClickIcon} src={logo} className="soloHeader_baseLeftImg" />
        {props.confirmCheck === undefined && props.reserveCheck === undefined ?
          <>
            <div className="soloHeader_baseRight" tabIndex={props.tabIndex}>
              <Link linkTitle="＞予約内容の確認・キャンセルはこちら" className="soloHeader_linkLabel" onClick={() => onClickOpenReservationPopupWindow(login.memberCode)} />
            </div>
          </>
          : null
        }
      </div>
      <div className="soloHeader_base">
        <div className="soloHeader_baseCenter">
          {isWideTablet && props.path ?
            <div className="soloHeader_backButton" onClick={onClickBack}>＜</div>
            : null}
          <div className="soloHeader_titleWrapper">
            <div>
              <Label label={props.categoryLabel1} className="soloHeader_labelStyle1" />
              <Label label={props.categoryLabel2} className="soloHeader_labelStyle2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};